import sorting from './sub/index-sort';

class index {
  constructor() {

    var parent = this;

    this.viewButsShowing = true;
    this.prevTop = 0;
    this.prevTopCounter = 0;

    console.log(this.inited);

    if(!this.inited){
      this.inited = true;

      if(MOBILE) {
        $('[mob-src]').each(function(){
          var mobSrc = $(this).attr('mob-src');
          $(this).attr('src', mobSrc);
        });

        $('[data-mob-srcset]').each(function(){
          var dataMobSrcsetJpeg = $(this).attr('data-mob-srcset-jpeg');
          var dataMobSrcset = $(this).attr('data-mob-srcset');
          var dataMobSrc = $(this).attr('data-mob-src');
          $(this).attr('data-srcset-jpeg', dataMobSrcsetJpeg);
          $(this).attr('data-srcset', dataMobSrcset);
          $(this).attr('data-src', dataMobSrc);
        });
      }

      window.itemFilterTime = [];

      window.projectGroups = $('.index--wrap--past, .index--wrap--future').toArray();
      for(let g=0; g<window.projectGroups.length;g++) {
        window.projectGroups[g].projects = $(window.projectGroups[g]).find('.index-project').toArray();

        window.projectGroups[g].projects.forEach((t) => {
          t.data = {};
          t.data.tags = t.dataset.tags.split(', ');
          t.data.types = t.dataset.type.split(',');
          t.data.text = t.dataset.text;
          // console.log(t.data);

          // var title = $(t.link).attr('data-title');
          // var words = title.split(' ');
          // var html = '';
          // for(var i=0;i<words.length;i++){
          //   html += '<span>'+words[i]+'</span> ';
          // }
          // t.data.heading = html;
        });
      }

      window.imgProjects = $('.image--project').toArray();
      window.imgProjects.forEach((t) => {
        t.data = {};
        t.link = $(t).find('.projectlink--image');
        t.data.tags = t.dataset.tags.split(', ');
        t.data.types = t.dataset.type.split(',');
        t.data.text = t.dataset.text;

        var title = $(t.link).attr('data-title');
        var words = title.split(' ');
        var html = '';
        for(var i=0;i<words.length;i++){
          html += '<span>'+words[i]+'</span> ';
        }
        t.heading = html;
      });

      this.setSizes();

      /*
        $(document).unbind('mousemove').mousemove(function(e){
          var onabutton = false;
          let x = e.pageX;
          let y = e.pageY;
          console.log(x,y);
          $('.index--filters .but').each(function(){
              let rect = this.getBoundingClientRect();
              //console.log(rect);
              if(rect.top < y && rect.bottom > y){
                  console.log(rect);
              if(rect.left < x && rect.right > x){
                      console.log('IS IN!');
                      onabutton = true;
                  }
              }
          });
          console.log(onabutton);
          if(!onabutton) {
              $('.index--filters').addClass('no-pointer');
          } else {
              $('.index--filters').removeClass('no-pointer');
          }
        });
      */

      // var tar = null;
      // if($('.end-sticky').length>0){
      //   tar = '.end-sticky';
      // } else {
      //   tar = window;
      // }

      $(window).on('load', function(){
        window.loaded = true;
      });

      $(window).on('resize', function(){
        if(!window.isList && window.loaded) {
          clearTimeout(window.rszTime);
          window.rszTime = setTimeout(function(){
            window.imgProjects.forEach((t) => {
              if(t.allowed){
                parent.calculateImageSize(t);
              }
            });
          }, 1000);
        }
      });

      $(window).scroll(function(e){
        if($('html').hasClass('index')){
          if(!window.noScrollDetect && !window.navigating){
            var top = $(window).scrollTop();
            let animViewButs = false;
            if(top > 3) {
              if(parent.prevTop < top) { // going down
                parent.prevTopCounter = 0;
              } else { // going up
                parent.prevTopCounter++;
              }
              // console.log(parent.prevTopCounter);
              if(parent.prevTopCounter > 5 && !parent.viewButsShowing) {
                // parent.prevTopCounter = 0;
                parent.viewButsShowing = true;
                animViewButs = true;
              } else if(parent.viewButsShowing && parent.prevTopCounter==0){
                parent.viewButsShowing = false;
                animViewButs = true;
              }
              if(animViewButs) {
                if(parent.viewButsShowing) {
                  $('.index-views').removeClass('out');
                }
                if(!parent.viewButsShowing ){
                  $('.index-views').addClass('out');
                }
              }
            } else {
              parent.viewButsShowing = true;
              $('.index-views').removeClass('out');
            }
          }

          parent.prevTop = top;

          if(!window.isList) {
            window.imgProjects.forEach((t) => {
              if(t.allowed){
                parent.calculateImageSize(t);
              }
            });
          }

          if(!window.noScrollDetect){
            let colophonRect = $('.colophon').get(0).getBoundingClientRect();
            if(colophonRect.top - 10 < window.innerHeight) {
              $('.index--filters').addClass('out');
            } else {
              $('.index--filters').removeClass('out');
            }
          }
        }
      });

      $(window).on('resize', this.setSizes);

      if(window.innerWidth < 787){ // && window.innerWidth < window.innerHeight) {
        this.topPos = 0;
        if(!this.mobileHoverInited){
          this.initMobileHover();
        }
        $('.index--filters--advanced,.index--filters--basic').each(function(){
          let max = $(this).get(0).scrollWidth;
          // console.log(max);
          let pos = max/2 - window.innerWidth/2;
          $(this).scrollLeft(pos);
        });
      } else {
        $('.index-project--wrap span').unbind('mouseenter mouseleave').mouseenter(function(){
          if(!window.preventTitleHovers) {
            clearTimeout(this.outTime);
            var t = this;
            var tar = $(t).parents('.index-project--wrap');
            if($(tar).is('a')){
              $(tar).addClass('orange');
            } else if ($(tar).find('img').length>0) {
              $(tar).addClass('orange');
            }
            this.inTime = setTimeout(function(){
              // if($(t).is(':hover')){
                $('.index-project--wrap.enter img').each(function(){
                  $(this).css('z-index', parseInt($(this).css('z-index')-1));
                });
                $(tar).find('img').css('z-index','-1');
                $(tar).removeClass('out').addClass('enter');
                if($(tar).find('video').length>0) {
                  $(tar).find('video').css('z-index','-1');
                  $(tar).find('video').get(0).play();
                }
              // }
            }, 150);
          }
        }).mouseleave(function(e){
          clearTimeout(this.inTime);
          // if(!window.preventTitleHovers) {
            var t = this;
            var tar = $(t).parents('.index-project--wrap');
            $(tar).removeClass('orange');
            this.outTime = setTimeout(function(){
              $(tar).addClass('out').removeClass('enter');
              if($(tar).find('video').length>0) {
                $(tar).find('video').get(0).pause();
              }

              setTimeout(function(){
                $(tar).removeClass('out');
              }, 500);
            }, 700);
          // }
        });
      }

      this.initImageIndex();

      if(!this.filtersInited) {
        this.initFilters();
      }

      var beenToImages = localStorage.getItem('note-indexView')=='images';
      console.log('been to images :',beenToImages);

      window.isList = !beenToImages;

      if(!MOBILE) {
        if(localStorage.getItem('note-indextitledone')=='yes'){
          setTimeout(function(){
            if(!beenToImages) {
              $('.index--wrap').addClass('in');
            } else {
              if(!$('.index-views--tog.images').hasClass('act')){
                window.firstClickToImages = true;
                $('.index-views--tog.images').click();
                window.firstClickToImages = false;
              }
            }
          }, 200);
        } else {
          setTimeout(function(){
            if(!beenToImages) {
              $('.index--wrap').addClass('in');
            } else {
              $('.index-views--tog.images').click();
            }
          }, 1700);
        }
      } else {
        setTimeout(function(){
          if(!beenToImages) {
            $('.index--wrap').addClass('in');
          } else {
            $('.index-views--tog.images').click();
          }
        }, 200);
      }

      var parent = this;
      // SHOW ALL

      setTimeout(function(){
        $('.index--filters, .index-views').removeClass('out');
        $('.index--wrap').addClass('in');

        parent.initViews();

        $('.index-project:not(.out)').css('max-height','1.3em');

        gsap.to('.index--wrap--headers, .index-project:not(.out)', {
          opacity: 1,
          duration: 0,
          stagger: 0.026,
          onComplete: function(){
            $('.index-project.out').css('opacity',1);
          }
        });
      }, 800);
    }


    window.sorting = new sorting();
  }

  initImageIndex() {
    if(!TOUCH) {
      $('.projectlink--image')
      .unbind('mouseenter mouseleave')
      .mouseenter(function(){
        if(!window.preventTitleHovers) {
          var t = $(this).attr('data-title');
          var words = t.split(' ');
          var html = '';
          for(var i=0;i<words.length;i++){
            html += '<span>'+words[i]+'</span> ';
          }
          $('.image-index--title').addClass('in').html(html);
        }
      }).mouseleave(function(){
        // if(!window.preventTitleHovers) {
          $('.image-index--title').removeClass('in');
        // }
      });
    } else {
      $('.projectlink--image')
      .click(function(){
        var t = $(this).attr('data-title');
        var words = t.split(' ');
        var html = '';
        for(var i=0;i<words.length;i++){
          html += '<span>'+words[i]+'</span> ';
        }
        $('.image-index--title').addClass('in').html(html);
      });
    }
  }

  initViews() {
    let ETYPE = TOUCH ? 'touchend' : 'click';
    $('.index-views--tog').unbind(ETYPE).on(ETYPE, function(e){
      e.preventDefault();

      window.prevScroll = 0;

      $('.index--wrap').addClass('instant');
      $(this).toggleClass('act');
      let doImgs = false;
      if($(this).hasClass('act')){
        if($(this).hasClass('images')){
          doImgs = true;
        }
      } else {
        if($(this).hasClass('images')){
          $('.image-index--title').removeClass('in');
          doImgs = false;
        }
      }

      console.log('clicked link');

      if(doImgs) {
        console.log('you triggered to do images');
        localStorage.setItem('note-indexView', 'images');
        // setTimeout(function(){
          $('.index-views--tog.images').addClass('act');
          $('.index-views--tog.list').removeClass('act');
          $('.index--wrap').removeClass('in');
          window.isList = false;
            gsap.to('.index--wrap', {
              opacity: 0,
              duration: 0.3,
              onComplete: function(){
                $('.index--wrap').hide();
                setTimeout(function(){
                  console.log('calling scrolltop');
                  $(window).scrollTop(0);

                  $('.image-index--wrap').css('opacity',0).show();
                  setTimeout(function(){
                    gsap.to('.image-index--wrap', {
                      opacity : 1,
                      duration: 0.4,
                      onComplete : function(){
                        console.log('image-index--wrap faded in, this is callback after 400ms anim')
                        $(window).scrollTop(0);
                        $('.index--wrap').removeClass('in');
                      }
                    });

                    // if(MOBILE) {
                    $('html').scrollTop(2);
                    gsap.to('html', {
                      scrollTop : 0,
                      duration: 0.4,
                    });
                    // }
                  },100);
                },50);
              }
            });
      } else { // do list
        console.log('you triggered to do list');
        window.isList = true;
        localStorage.setItem('note-indexView', 'list');
        $('.index-views--tog.images').removeClass('act');
        $('.index-views--tog.list').addClass('act');

        gsap.to('.image-index--wrap', {
          opacity: 0,
          duration: 0.3,
          onComplete: function(){
            // console.log('image-index--wrap faded out, this is callback after 400ms anim')
            // $(window).scrollTop(0);
            $('.image-index--wrap').hide();
            $('.index--wrap').css('opacity',0).show();
            $(window).scrollTop(0);
            gsap.to('.index--wrap', {
              opacity: 1,
              duration: 0.3,
              onComplete: function(){
                $('.index--wrap').addClass('in');
              }
            });
            // $('.index--wrap').fadeIn(400, function(){
            //   $('.index--wrap').addClass('in');
            //   console.log('index--wrap fading in, this is callback after 400ms anim');
            // });
          }
        });
        /*
        $('.index-views--tog.images').removeClass('act');
        $('.index-views--tog.list').addClass('act');
        $('.index--wrap').removeClass('instant');
        $('.image-index--wrap').fadeOut(400, function(){
          console.log('image-index--wrap faded out, this is callback after 400ms anim')
          $(window).scrollTop(0);
          $('.index--wrap').fadeIn(400, function(){
            $('.index--wrap').addClass('in');
            console.log('index--wrap fading in, this is callback after 400ms anim');
          });
        });
        */
      }
    });

    if(!TOUCH) {
      $('.index-views--tog').unbind('mouseenter mouseleave').mouseenter(function(){
        $(this).addClass('hover');
      }).mouseleave(function(){
        $(this).removeClass('hover');
      });
    } else {
      $('.index-views--tog').unbind('mouseenter mouseleave');
      setTimeout(function(){
        $('.index-views--tog').unbind('mouseenter mouseleave');
      }, 200);
    }
  }

  initFilters(){
    var self = this;
    if(!this.filtersInited){
      this.filtersInited = true;

      $('.index--filters a.advanced').unbind('click').click(function(e){
        e.preventDefault();
        $(this).find('span').text($(this).text()=='Advanced' ? 'Close' : 'Advanced');
        $(this).toggleClass('act');
        var isAct = $(this).hasClass('act');
        $('.index--filters--advanced').toggleClass('events');
        $('.index--filters--advanced').children().each(function(){
          var t = this;
          if(isAct) {
            $(t).addClass('in');
          } else {
            $(t).removeClass('in');
          }
        });
      });

      $('.clear-filters').unbind('click').click(function(e){
        e.preventDefault();
        $('.filters--search--input').val('');
        localStorage.setItem('note-searchText','');
        window.searchText = false;

        $('.index--filters a.tag').removeClass('act');
        $('.index--filters a.type').addClass('act');
        window.activeTypes = ['Spatial', 'Visual Communication', 'Product'];
        window.activeTags = [];

        localStorage.setItem('note-activeTags','');
        localStorage.setItem('note-activeTypes','');

        self.checkFilters();

        if(MOBILE) {
          if(!window.isList) {
            gsap.to('html', {
              scrollTop : 0,
              duration: 0.4,
            });
          }
        }
      });

      $('.tog-filters').unbind('click').click(function(e){
        e.preventDefault();

        $(this).text($(this).text()=='Filter' ? 'Close' : 'Filter');
        let open = $(this).text()=='Close';

        clearTimeout(window.togfilters);
        window.togfilters = setTimeout(function(){
          $('.index--filters--basic').toggleClass('in');
        }, open ? 10 : 100);

        clearTimeout(window.togAdvanced);
        window.togAdvanced = setTimeout(function(){
          $('.index--filters a.advanced').each(function(e){
            // e.preventDefault();
            $(this).find('span').text($(this).text()=='Advanced' ? 'Close' : 'Advanced');
            $(this).toggleClass('act');
            var isAct = $(this).hasClass('act');
            $('.index--filters--advanced').toggleClass('events');
            $('.index--filters--advanced').children().each(function(){
              var t = this;
              if(isAct) {
                $(t).addClass('in');
              } else {
                $(t).removeClass('in');
              }
            });
          });
        }, open ? 100 : 10);
      });

      $('.filters--search--input').off('keyup').on('keyup', function(){
        var val = $(this).val();
        if(val.length>2) {
          localStorage.setItem('note-searchText', val);
          window.searchText = val.toLowerCase();
          // $(this).removeClass('gray');
        } else {
          localStorage.setItem('note-searchText','');
          window.searchText = false;
          // $(this).addClass('gray');
        }
        self.checkFilters();
      });

      $('.filters--search--clear').unbind('click').click(function(e){
        e.preventDefault();
        $('.filters--search--input').val('');
        localStorage.setItem('note-searchText','');
        window.searchText = false;
        self.checkFilters();
      });


      window.searchText = false;
      if(localStorage.getItem('note-searchText')){
        $('.filters--search--input').val(localStorage.getItem('note-searchText'));
        window.searchText = localStorage.getItem('note-searchText').toLowerCase();
      }

      window.activeTypes = [];
      window.activeTags = [];

      if(localStorage.getItem('note-activeTags')){
        window.activeTags = localStorage.getItem('note-activeTags').split(',');
      }
      if(localStorage.getItem('note-activeTypes')){
        window.activeTypes = localStorage.getItem('note-activeTypes').split(',');
      } else {
        $('.index--filters a.type').each(function(){
          var text = $(this).text();
          window.activeTypes.push(text);
        });
      }

      $('.index--filters a.tag').unbind('click').click(function(e){
        e.preventDefault();
        $(this).toggleClass('act');
        $(this).addClass('no-hover');
        var text = $(this).text();

        if(!$(this).hasClass('act')){
          var index = window.activeTags.indexOf(text);
          window.activeTags.splice(index,1);
        } else {
          // console.log('pushing',text);
          window.activeTags.push(text);
        }

        localStorage.setItem('note-activeTags', window.activeTags);

        self.checkFilters();
      }).mouseleave(function(){
        $(this).removeClass('no-hover');
      });

      $('.index--filters a.type').each(function(){
        // var text = $(this).text();
        // window.activeTypes.push(text);
      }).unbind('click').click(function(e){
        e.preventDefault();
        $(this).toggleClass('act');
        $(this).addClass('no-hover');
        var text = $(this).text();

        if(!$(this).hasClass('act')){
          var index = window.activeTypes.indexOf(text);
          window.activeTypes.splice(index,1);
        } else {
          window.activeTypes.push(text);
        }

        localStorage.setItem('note-activeTypes', window.activeTypes);

        self.checkFilters();
      }).mouseleave(function(){
        $(this).removeClass('no-hover');
      });

      var shouldBeOpen = false;

      if(window.activeTypes.length<3 || window.activeTags.length>0){
        this.checkFilters();

        $('.but.tog.type').each(function(){
          var t = $(this).text();
          if(window.activeTypes.indexOf(t)<0){
            $(this).removeClass('act');
          }
        });

        var totalActiveTags = 0;
        $('.but.tog.tag').each(function(){
          var t = $(this).text();
          if(window.activeTags.indexOf(t)>=0){
            $(this).addClass('act');
            totalActiveTags++;
          }
        });

        if(window.innerWidth >= 786) {
          $('.index--filters--basic').addClass('in');
          $('.tog-filters').text('Close');

          if(totalActiveTags>0) {
            setTimeout(function(){
              $('.but.advanced').click();
            }, 900);
          }
        } else {
          shouldBeOpen = true;

          $('.index--filters--advanced').each(function(){
            var par = this;
            if($(this).find('.act').length>0) {
              let cur = $(par).scrollLeft();
              let pos = cur + $(this).find('.act').first().offset().left - 10;
              $(par).scrollLeft(pos);
            }
          });
        }
      } else if(window.searchText){
        this.checkFilters();

        if(window.innerWidth < 787) {
          setTimeout(function(){
            shouldBeOpen = true;
          }, 10);
        } else {
          $('.but.advanced').click();
        }
      }

      if(shouldBeOpen) {
        $('.tog-filters').click();
      }
    }
  }

  checkAllowed(types, tags, text){
    // let start = Date.now();
    let allowed = false;

    if(types) {
      for(let t=0;t<types.length;t++) {
        for(var i=0;i<window.activeTypes.length;i++){
          if(types[t] == window.activeTypes[i]){
            allowed = true;
          }
        }
      }
      /*
      let typesSplit = types.split(',');
      for(let t=0;t<typesSplit.length;t++) {
        for(var i=0;i<window.activeTypes.length;i++){
          if(typesSplit[t].trim() == window.activeTypes[i].trim()){
            allowed = true;
          }
        }
      } // each typesplit
      */
    } // if types

    if(allowed && window.activeTags.length>0){
      allowed = false;
      if(tags) {
        for(let t=0;t<tags.length;t++) {
          for(var n=0;n<window.activeTags.length;n++){
            if(tags[t].trim() == window.activeTags[n].trim()){
              // if(tags.indexOf(window.activeTags[n]) < 0){
              allowed = true;
            }
          }
        } // each tag
        /*
        let tagsSplit = tags.split(',');
        for(let t=0;t<tagsSplit.length;t++) {
          for(var n=0;n<window.activeTags.length;n++){
            if(tagsSplit[t].trim() == window.activeTags[n].trim()){
              // if(tags.indexOf(window.activeTags[n]) < 0){
              allowed = true;
            }
          }
        } // each tagsplit
        */
      } else {
        allowed = false;
      }
    } // check activetags

    if(allowed && window.searchText) {
      if(text) {
        // console.log(text.toLowerCase());
        if(text.indexOf(window.searchText) < 0){
          allowed = false;
        }
      } else {
        allowed = false;
      }
    }

    // let end = Date.now();
    // console.log('checkAllowed took '+ (start-end) +'ms');

    return allowed;
  }

  checkFilters(){
    var parent = this;

    console.log('checking filters');

    window.isList = $('.index--wrap').hasClass('in');
    // const DELAY = 12;

    clearTimeout(window.filterTitleTimeout);
    clearTimeout(window.filterScrollTimeout);

    // for(var i=0;i<window.itemFilterTime.length;i++){
      // clearTimeout(window.itemFilterTime);
    // }

    // LIST INDEX

    var totalVisibles = 0;

    let alloweds = [];
    let notAlloweds = [];

    for(let g=0; g<window.projectGroups.length;g++) {

      // let start = Date.now();

      // $('.index--wrap--past, .index--wrap--future').each(function(){
      var visibleCount = 0;
      var par = window.projectGroups[g];

      // for(let p = 0; p<window.projectGroups[g].projects.length; p++) {
      // let t = window.projectGroups[g].projects[p];
      window.projectGroups[g].projects.forEach((t) => {
        // var t = el;

        // window.itemFilterTime[idx] = setTimeout(function(){
        var types = t.data.types; // $(t).attr('data-type');
        var tags = t.data.tags; // $(t).attr('data-tags');
        var text = t.data.text; //$(t).text();

        let allowed = parent.checkAllowed(types, tags, text);

        if(allowed) {
          if($(t).hasClass('out')) {
            $(t).removeClass('out');
            // alloweds.push(t);
          }
          visibleCount++;
        } else {
          if(!$(t).hasClass('out')){
            $(t).addClass('out');
            // notAlloweds.push(t);
          }
        }

        // let end = Date.now();
        // console.log('filtering '+g+'['+t+'] took '+ (start-end) +'ms');

        // }, idx*DELAY);
      }); // foreach
      // }

      // window.filterTitleTimeout = setTimeout(function(){

      if(visibleCount==0) {
        $(par).addClass('zero');
        if($(par).hasClass('index--wrap--future')){
          if(window.isList) { $('.future-headers').hide() } else { $('.future-headers').hide(); }
        } else {
          if(window.isList) { $('.past-headers').hide() } else { $('.past-headers').hide(); }
        }
      } else {
        $(par).removeClass('zero');
        if($(par).hasClass('index--wrap--future')){
          if(window.isList) { $('.future-headers').show() } else { $('.future-headers').show(); }
        } else {
          if(window.isList) { $('.past-headers').show() } else { $('.past-headers').show(); }
        }
      }

      totalVisibles += visibleCount;

      // }, $(par).find('.index-project').length*DELAY + 50);

    } // foreach project group

    // if(alloweds.length){
    //   gsap.to(alloweds, {
    //     opacity: 1,
    //     maxHeight: '1.3em',
    //     duration: 0.2,
    //     stagger: 0.01,
    //     // opacity: 1,
    //   });
    // }
    // if(notAlloweds.length){
    //   gsap.to(notAlloweds, {
    //     opacity: 0,
    //     maxHeight: 0,
    //     duration: 0.2,
    //     stagger: 0.01,
    //     // opacity: 0,
    //   });
    // }

    window.noScrollDetect = true;
    window.filterScrollTimeout = setTimeout(function(){
      if($(window).scrollTop() + window.innerHeight >= $('.colophon').position().top - 49){
        $('html,body').animate({'scrollTop' : ($('.colophon').position().top - 50)-window.innerHeight},500, function(){
          window.noScrollDetect = false;
        });
      } else {
        window.noScrollDetect = false;
      }
    }, 200);

    if(totalVisibles==0) {
      console.log('none are visible!');
      if(window.isList) {
        $('.index--wrap--empty').show();
        $('.image-index--wrap--empty').show();
      } else {
        $('.index--wrap--empty').show();
        $('.image-index--wrap--empty').show();
        $('.image-index--title').removeClass('in');
      }
      $('.index--wrap, .image-index--wrap').addClass('empty');
    } else {
      if(window.isList) {
        $('.index--wrap--empty').hide();
        $('.image-index--wrap--empty').hide();
      } else {
        $('.image-index--wrap--empty').hide();
        $('.index--wrap--empty').hide();
      }
      $('.index--wrap, .image-index--wrap').removeClass('empty');
    }
    // });

    // IMAGE INDEX

    // $('.image--project').each(function(){
    var imgProjectsAllowed = 0;
    window.imgProjects.forEach((t) => {
      var types = t.data.types; //$(t).attr('data-type');
      var tags = t.data.tags; //$(t).attr('data-tags');
      var text = t.data.text; //$(t).attr('data-text');

      let allowed = parent.checkAllowed(types, tags, text);
      let sibs = $(t).siblings();
      t.allowed = allowed;
      // console.log(allowed);
      if(!allowed) {
        t.disabled = true;
        $(t).addClass('disabled');
        $(t).parents('.content-block').addClass('some-out');

        let allSibsDis = $(t).siblings('.disabled').length == sibs.length;
        if(sibs.length==0||allSibsDis){
          if(!window.isList) {
            // $(t).parents('.content-block').slideUp(400).addClass('out');
            $(t).parents('.content-block').css('max-height','0').addClass('out');
          } else {
            // $(t).parents('.content-block').hide().addClass('out');
            $(t).parents('.content-block').css('max-height','0').addClass('out');
          }
        }
      } else {
        t.disabled = false;
        $(t).removeClass('disabled');
        parent.calculateImageSize(t);
        let noSibsDis = $(t).siblings('.disabled').length == 0;
        if(noSibsDis) {
          $(t).parents('.content-block').removeClass('some-out');
        }
        imgProjectsAllowed++;
      }
    });


    if(window.activeTags.length>0 || window.activeTypes.length!==3 || window.searchText) {
      $('.index--wrap--banner, .image-index--wrap .scroller').addClass('out');
      $('.index--filters').addClass('show-clear');
      $('.index--wrap, .image-index--wrap').addClass('filtered');
    } else {
      $('.index--wrap--banner, .image-index--wrap .scroller').removeClass('out');
      $('.index--filters').removeClass('show-clear');
      $('.index--wrap, .image-index--wrap').removeClass('filtered');
    }

    if(window.searchText) {
      $('.filters--search--clear').addClass('in');
    } else {
      $('.filters--search--clear').removeClass('in');
    }

    if(!MOBILE) {
      $(window).trigger('scroll');

      if(!window.isList && imgProjectsAllowed==0) {
        window.noScrollDetect = true;
        $('html,body').animate({'scrollTop' : 0 }, 500, function(){
          window.noScrollDetect = false;
        });
      }
    } else {
      if(!window.isList) {
        gsap.to('html', {
          scrollTop : 0,
          duration: 0.4,
        });
      }
      // window.noScrollDetect = true;
      // $('html, body').animate({'scrollTop':0}, 500, function(){
      //   window.noScrollDetect = false;
      // });
    }
  } // end checkfilters

  calculateImageSize(t) {
    if(window.loaded) {
      var contH = $(t).parents('.content-block').children('.imageset--wrap').outerHeight();
      $(t).parents('.content-block')
      .removeClass('out')
      .css({
        'max-height' : contH+'px'
      });
    }
  }

  setSizes(){
    $('.index-project--wrap').each(function(e){
      var w = $(this).find('.index-project--image').outerWidth();
      var h = $(this).find('.index-project--image').outerHeight();
      $(this).find('.index-project--image:not(.l)').css({
        'left' : Math.random()*(window.innerWidth*.8 - w) + window.innerWidth*.1,
        'top' : Math.random()*(window.innerHeight*.8 - h) + window.innerHeight*.1,
      });
    });
  }

  initMobileHover(){
    console.log('inited mobile hover');
    this.topPos = 250; //$('.past-headers').position().top;
    var self = this;
    self.mobileHoverInited = true;
    $(window).scroll(function(){
      if($('html').hasClass('index')){
        if(!window.preventTitleHovers && !window.noScrollDetect) {
          // console.log('mobile hov scrolling');
          if(window.isList) {
            let act = null;
            for(let g=0; g<window.projectGroups.length;g++) {
              // var par = window.projectGroups[g];
              window.projectGroups[g].projects.forEach((block) => {
                var rect = block.getBoundingClientRect();
                if(rect.top <= self.topPos && rect.bottom >= self.topPos) {
                  act = block;
                }
              });
            }

            if(act) {
              $('.index-project.hover').removeClass('hover');
              $(act).addClass('hover');
              if($(act).find('video').length>0) {
                $(act).find('video').get(0).play();
              }
            } else {
              $('.index-project.hover video').each(function(){
                this.pause();
              });
              $('.index-project.hover').removeClass('hover');
            }
          } else { // NOT window.isList, so mobile image index
            var somethingInFocus = false;
            if($(window).scrollTop()>1) {
              for(var i=0; i<window.imgProjects.length;i++){
                let block = window.imgProjects[i];
                if(!block.disabled) {
                  // console.log('checking non disabled block');
                  var inFocus = block.getBoundingClientRect().top < (window.vh*50) && block.getBoundingClientRect().bottom > (window.vh*50);
                  if(inFocus) {
                    somethingInFocus = true;
                  }
                  if(inFocus && window.focusedBlock !== block){
                    window.focusedBlock = block;
                    console.log('found in focus, heading is: ',block.heading);
                    // $(block.link).trigger('mouseenter');
                    $('.image-index--title').addClass('in').html(block.heading);
                  }
                }
              }
            }

            if(!somethingInFocus) {
              $('.image-index--title').empty();
              window.focusedBlock = null;
            }
          }
        }
      }
    });

    $(window).trigger('scroll');
  }
}

export default index;
